const config = {
    baseUri: process.env.REACT_APP_BASE_URI,
    baseQli: process.env.REACT_APP_BASE_QLI
}

export default config